/* loaded by smart-asset */
export default require("./7~hmJecVeD.svg")